module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="calendar">\n  <h2>Legislative Calendar</h2>\n  <!-- <div class="calendar-items"></div> -->\n<!-- <div class="col-1">\n  <i id="events-previous" class="fa fa-angle-left fa-4x"></i>\n</div>\n<div class="col-10">-->\n  <div id="days" class="calendar-items days-list row justify-content-around-md"></div>\n<!--</div>\n<div class="col-1 text-end">\n  <i id="events-next" class="fa fa-angle-right fa-4x"></i>\n</div> -->\n</div>';
}
return __p;
};
